import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import { config } from 'react-awesome-styled-grid'
export const SoundWaveAnimation = (props: { isActive: boolean }): React.ReactNode => {
  return (
    <SoundBars className='soundbars' isPlaying={props.isActive}>
      <span className="bar-1"></span>
      <span className="bar-2"></span>
      <span className="bar-3"></span>
      <span className="bar-4"></span>
      <span className="bar-5"></span>
      <span className="bar-6"></span>
      <span className="bar-7"></span>
      <span className="bar-8"></span>
      <span className="bar-9"></span>
    </SoundBars>
  )
}

const SoundBars = styled.div<any>`
  align-items: center;
  display: flex;
  margin-bottom: 12px;
  ${(props: any): any => config(props).media.lg`
    height: 20px;
    margin-bottom: 18px;
  `}
  span {
    background-color: ${colors.sand};
    height: 14px;
    width: 1px;
    margin: 0 1.5px;
    ${(props: any): any => config(props).media.lg`
      margin: 0 2px;
      height: 16px;
    `}
  }
  .bar-1,
  .bar-5,
  .bar-9 {
    transform: scaleY(0.5);
  }
  .bar-2,
  .bar-4,
  .bar-6,
  .bar-8 {
    transform: scaleY(0.71);
  }

  ${(props: { isPlaying: boolean }): string | null | undefined => {
    if (props.isPlaying) {
      return `
        .bar-1, .bar-3, .bar-7 {
          animation: barHeight .5s .5s infinite;
        }
        .bar-2, .bar-6, .bar-9 {
          animation: barHeight2 .6s .5s infinite;
        }
        .bar-4, .bar-5, .bar-8 {
          animation: barHeight2 .5s .5s infinite;
        }
      `
    }
  }}
  @keyframes barHeight {
    0% {
      transform: scaleY(1.25);
    }
    50% {
      transform: scaleY(0.5);
    }
    100% {
      transform: scaleY(1);
    }
  }
  @keyframes barHeight2 {
    0% {
      transform: scaleY(0.5);
    }
    50% {
      transform: scaleY(1);
    }
    100% {
      transform: scaleY(0.5);
    }
  }
  @keyframes barHeight3 {
    0% {
      transform: scaleY(0.7);
    }
    50% {
      transform: scaleY(1.2);
    }
    100% {
      transform: scaleY(0.5);
    }
  }
`
